import ExperimentDtoClient from 'business/models/ExperimentDtoClient';
import {
  LayerTypeDTO,
  RandomLayerDTO,
  RandomLayerIngredientGroupDTO,
} from 'business/models/Models';
import {
  getIngIngType,
  getIngredient,
  getIngStock,
} from 'business/plateviewer/Generate/GenerateCommon';
import { getIngredientType } from 'utils/Global';
import { TABLE_LAYOUT } from './ExperimentReportPDF';

export function randomLayerDetaiSubReport(content: any[], expData: ExperimentDtoClient) {
  const randomLayers = expData.layers.filter((lyr) => lyr.type === LayerTypeDTO.Random);
  randomLayers.forEach((lyr) => {
    const lyrDetail: RandomLayerDTO = lyr.layerDetail as RandomLayerDTO;
    content.push({
      text: '\n' + lyr.name + ' - ' + (lyr.height + 1) + ' x ' + (lyr.width + 1) + '\n',
      style: 'largeText',
    });
    content.push({
      text: 'Grid Steps: ' + lyrDetail.gridSteps + '\n',
      style: 'labelText',
    });
    let groupsRow: any = {
      columns: [
        { text: 'Generation List', style: 'labelText', width: '45%' },
        {
          text: 'Exclude List' /*(lyrDetail.randomLayerExcludeList.length > 0 ? 'Exclude List' :'')*/,
          style: 'labelText',
          width: '45%',
          marginLeft: 20,
        },
      ],
    };
    content.push(groupsRow);
    groupsRow = {
      columns: [randomLayerGroupsTable(lyrDetail), excludeListTable(lyrDetail)],
    };
    content.push(groupsRow);
    lyrDetail.randomLayerIngredientGroup.forEach((ingGroup) => {
      if (ingGroup.randomLayerGroupIngredient.length > 0) {
        content.push({
          text: "\nIngredients for the '" + ingGroup.name + "' Group\n",
          style: 'headerText',
        });
        content.push(groupIngredientListTable(ingGroup));
      }
    });
  });
}

function groupIngredientListTable(ingGroup: RandomLayerIngredientGroupDTO) {
  const body: any = [
    [
      { text: 'Type', bold: true },
      { text: 'Name', bold: true },
      { text: 'Stock Conc.', bold: true },
      { text: 'Stock Low pH', bold: true },
      { text: 'Stock High pH', bold: true },
      { text: 'Min Conc.', bold: true },
      { text: 'Max Conc.', bold: true },
      { text: 'Min pH', bold: true },
      { text: 'Max pH', bold: true },
      { text: 'Weight', bold: true },
      { text: 'Probability', bold: true },
    ],
  ];

  ingGroup.randomLayerGroupIngredient.forEach((groupIng) => {
    const ingIngType = getIngIngType(groupIng.ingredientIngredientTypeId);
    const ingType = getIngredientType(ingIngType.ingredientTypeId);
    const ingredient = getIngredient(ingIngType.ingredientId);
    const ingStock = getIngStock(groupIng.ingredientStockId);
    const highPhIngStock = getIngStock(groupIng.highPhingredientStockId);
    body.push([
      ingType.name,
      ingredient.longName,
      ingStock.stockConcentration + ' ' + ingStock.concentrationUnits,
      ingStock.isBuffer ? ingStock.stockPh : '',
      ingStock.isBuffer && highPhIngStock ? highPhIngStock.stockPh : '',
      groupIng.lowConcentration + ' ' + ingStock.concentrationUnits,
      groupIng.highConcentration + ' ' + ingStock.concentrationUnits,
      groupIng.lowPh ? groupIng.lowPh : '',
      groupIng.highPh ? groupIng.highPh : '',
      groupIng.weight,
      ingGroup.randomLayerGenerationList.length > 0
        ? ingGroup.randomLayerGenerationList[0].probability
        : '',
    ]);
  });

  return {
    table: {
      widths: ['15%', '24%', '8%', '7%', '7%', '7%', '7%', '5%', '5%', '6%', '9%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}

function excludeListTable(lyrDetail: RandomLayerDTO) {
  const body: any = [
    [
      { text: 'Ingredient 1', bold: true },
      { text: 'Ingredient 2', bold: true },
    ],
  ];
  lyrDetail.randomLayerExcludeList.forEach((exclude) => {
    body.push([exclude.ingredient1.longName, exclude.ingredient2.longName]);
  });

  return {
    marginLeft: 20,
    width: '45%',
    table: {
      widths: ['50%', '50%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}

function randomLayerGroupsTable(lyrDetail: RandomLayerDTO) {
  const body: any = [
    [
      { text: 'Group Name', bold: true },
      { text: 'Probability(0-1)', bold: true },
    ],
  ];
  lyrDetail.randomLayerIngredientGroup.forEach((grp) => {
    grp.randomLayerGenerationList.forEach((gl) => {
      body.push([grp.name, gl.probability]);
    });
  });

  return {
    width: '45%',
    table: {
      widths: ['50%', '50%'],
      headerRows: 1,
      body: body,
    },
    layout: TABLE_LAYOUT,
  };
}
